/** Product catalog category (BE `category`) — Security. UI nav/folders stay named Security. */
export const SECURITY_CATEGORY_ID = 'security' as const;
export const SECURITY_CATEGORY_LABEL = 'Security';

/** Product catalog domain (BE `domain`) for EDR. */
export const OBSERVABILITY_DOMAIN_ID = 'observability' as const;
export const OBSERVABILITY_DOMAIN_LABEL = 'Observability';

/** Registry + BE `solution` slug for the EDR product (Security category / Observability domain). */
export const EDR_SOLUTION_ID = 'edr' as const;
